"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnEntityAddedToGroup = void 0;
/**
 * @public
 * Emitted on entity being added to a group, not emitted if entity is already in the group.
 */
class OnEntityAddedToGroup {
    constructor(onEntityAddedToGroup) {
        this.onEntityAddedToGroup = onEntityAddedToGroup;
    }
    static registerListener(plot, onEvent) {
        return plot.eventService
            .getCategory(OnEntityAddedToGroup)
            .addTemporaryListener(new OnEntityAddedToGroup(onEvent));
    }
    static registerOneTimeListener(plot, onEvent) {
        return plot.eventService
            .getCategory(OnEntityAddedToGroup)
            .addOneTimeListener(new OnEntityAddedToGroup(onEvent));
    }
    static emit(plot, entity, group) {
        const listeners = plot.eventService
            .getCategory(OnEntityAddedToGroup)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onEntityAddedToGroup(entity, group);
        }
    }
}
exports.OnEntityAddedToGroup = OnEntityAddedToGroup;
OnEntityAddedToGroup.callbackKey = "onEntityAddedToGroup";
//# sourceMappingURL=on-entity-added-to-group.js.map